import api from './api';
import { bool } from 'yup';
import Axios from 'axios';
import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import { isObjNotEmpty } from '@app/helpers/objHelper';

const controller = "medicao";
export interface BoletimMedicao {
  id: string;
  fornecedorId: string;
  numeroDoContrato: string;
  tipoId: string;
  final: boolean;
  requerAnalisaSla: boolean;
  periodoInicial: Date;
  periodoFinal: Date;
}

export interface DadosGeriasBoletimMedicao {
  id: string;
  numero: number;
  statusId: string;
  tipoId: string;
  final: boolean;
  requerAnaliseSla: boolean;
  fornecedorId: string;
  nomeDoFornecedor: string;
  numeroDoContrato: string;
  numeroDoAditivo: number;
  periodoInicial: Date;
  periodoFinal: Date;
  justificativaDeAprovacaoComRessalva: string;
  contratoId: string;
  valid: boolean;
}

export interface AnexoMedicao {
  id: string;
  numero: number;
  nome: string;
  descricao: string;
  dataInclusaoFormatada: Date;
  responsavel: string;
  fileName: string;
}

export interface BoletimMedicaoAssinado {
  id: string;
  boletiMedicaoAssinado: string;
  dataInclusaoFormatada: Date;
  responsavel: string;
  observacao: string;
}

export interface AnexosMedicao {
  id: string;
  numero: number;
  nomeDoArquivo: string;
  descricao: string;
  dataHoraInclusao: string;
  responsavel: string;
  fileName: string;
}

export interface AnexoMedicaoAssinado {
  id: string;
  numero: number;
  nome: string;
  descricao: string;
  dataInclusaoFormatada: Date;
  responsavel: string;
  fileName: string;
}

export interface ItemMedicao {
  id: string;
  numeroLinha?: number;
  item: string;
  descricao: string;
  unidade: string;
  quantidade: string;
  preco: string;
  verbaTotal: string;

  qt_bl_anterior: string;
  qt_bl_periodo: string;
  qt_bl_acumulado: string;
  qt_bl_saldo: string;

  vlBoletimMedicao: string;
  vl_bl_anterior: string;

  vl_bl_periodo: string;
  vl_bl_acumulado: string;
  vl_bl_saldo: string;
  vl_bl_saldoPorcentagem: string;
  aprovadoString: string;

  aprovado: boolean;
  incontroverso: boolean;
  editable: boolean;
  usuarioPodeAlterarDados: boolean;

  contemAnexo: boolean;
  contemComentario: boolean;
  children?: ItemMedicao[];
}

export interface StatusMedicao {
  id: string;
  nome: string;
}

export interface StatusAutorizacaoPagamento {
  id: string;
  nome: string;
}

export interface TipoMedicao {
  id: string;
  nome: string;
}

export interface GetALlBmsPq {
  dados: CreatBoletimMedicaoPorContrato[];
}
export interface CreatBoletimMedicaoPorContrato {
  id: string;
  justificativaAprovacaoComRessalva: string;
  numero?: number;
  desrciaoStatusMedicao: string;
  nomeDoFornecedor: string;
  numeroDoContrato: string;
  statusAutorizacaoPagamentoId: string;
  contratoId: string;
  tipoId: string;
  statusMedicaoId: string;
  tipoMedicaoDescricao: string;
  descricaoStatus: string;

  periodoFimData?: Date;
  periodoInicioData?: Date;
  possuiSla?: boolean;
  solicitacaoCancelamento?: boolean;
  podeSerAprovadoComResalva?: boolean;

  final: boolean;
  complementar: boolean;
  faturamentoDireto: boolean;
  permiteFaturamentoDireto: boolean;
  evento: boolean;
  periodica: boolean;

  descricao: string;
  planilhaDeQuantidadeId: string;
  identificador: string
}

export interface ResumoMedicoe {
  id: string;
  Numero: number;
  Tipo: string;
  Status: string;
  Periodo: string;
  NmAditivoVigente: string;
  SlFinalMedicao: string;
  final: string;
  bonusSla: string;
  penaltSla: string;
  possuiSla: boolean;
  valorReal: string;
  statusProcessoAutorizacaoPagamento: string;
  statusRateio: string;
}

export interface ResumoMedicaoList {
  id: string;
  justificativaAprovacaoComRessalva: string;
  numero: string;
  periodoFim: string;
  periodoInicio: string;
  dataHoraSolicitacaoCancelamento: string;
  dataHoraUltimaTrocaStatusAutorizacaoPagamento: string;
  ultimaTrocaStatus: string;
  possuiSla: boolean;
  solicitacaoCancelamento: string;
  podeSerAprovadoComResalva: string;
  statusMedicaoId: string;
  desrciaoStatusMedicao: string;
  nomeDoFornecedor: string;
  numeroDoContrato: string;
  tipoMedicaoDescricao: string;
  descricaoStatus: string;
  statusAutorizacaoPagamentoId: string;
  contratoId: string;
  usuarioPodeEditar: boolean;
  statusConcluido: boolean;
  exibirAbaSla: boolean;
  statusCodigo: number;
  utilizaProcessoRateio: number;
  possuiPlanilhaDeRateio: boolean;
  mostraBotaoRateio: boolean;
  mostraAprovacaoEPagamento: boolean;
  aprovacaoEPagamentoAutomatica: boolean;
  pisCofins: boolean;
  escopo: string;
  identificadorPq?: string;
  justificativaCancelamento?: string;
}

export interface MedicaoEdit {
  id: string;
  numero: number;
  status: string;
  tipo: string;
  final: boolean;
  possuiSla: boolean;
  fornecedor: string;
  numeroDoContrato: string;
  numeroDoAditivo: string;
  periodoInicio: Date;
  periodoFim: Date;
  justificaAprovacaoResalva: string;
  justificativaCancelamentoMedicao: string;
  justificativaEscalarSla: string;
  statusConcluido: boolean;

  reprovarDadosQuantitativos: boolean;
  confirmarQuantidadeDoBm: boolean;
  aprovarRessalvaQuantidadeDoBm: boolean;
  reprovarRessalvaQuantidadeDoBm: boolean;
  analisouRessalvaReenviouBM: boolean;
  aprovarAnaliseQuantitativaBm: boolean;
  reprovarAnaliseQuantitativaBm: boolean;
  aprovarComRessalvaAnaliseQuantitativa: boolean;
  refutarAnaliseQuantitativa: boolean;
  reconfirmarQuantidadeBm: boolean;

  aprovarDadosBM: boolean;
  aprovarDadosBmComRessalva: boolean;
  refutarMedicao: boolean;
  confirmarMedicao: boolean;
  solicitarCancelamentoBoletimMedicao: boolean;
  aprovarCancelamentoBm: boolean;
  reprovarCancelamentoBm: boolean;
  confirmarSla: boolean;
  reprovarSla: boolean;
  usuarioPodeEditarInformacoes: boolean;
  mostrarBotaoAprovarComResalva: boolean;
  statusCodigo: number;

  reprovarQuantidadeDoPeriodo: boolean;

  complementar?: boolean;
  faturamentoDireto: boolean;
  evento?: boolean;
  periodica?: boolean;
  descricao: string;
  automatica?: boolean;

  dataHoraSolicitacaoCancelamento?: Date;
  ultimaTrocaStatus?: Date;

  confirmada?: boolean;

  statusSla: string;
  statusSlaCodigo: number;

  conclusaoSlaSolicitada: boolean;
  slaRefutado: boolean;
  slaPostergado: boolean;
  aprovadoComRessalva: boolean;
}

export interface Comentario {
  id: string;
  mensagem: string;
  mrn: boolean;
  nomeDoUsuario: string;
  nomeDoArquivo: string;
  possuiArquivo: boolean;
  dataHoraInclusao: Date;
}

export interface MedicaoTotalizador {
  medicaoAnterior: number;
  medicaoPeriodo: number;
  medicaoAcumulado: number;
  medicaoSaldo: number;
  medicaoValorContratoCriacao: number;
}

export interface Pendencia {
  item: string;
  descricao: string;
  unidade: string;
  quantidade: string;
  preco: string;
  verbaTotal: string;
  quantidadeAnterior: string;
  quantidadePeriodo: string;
  quantidadeAcumulado: string;
  quantidadeSaldo: string;
}

export interface MedicaoUsuarioPermissaoNivel {
  diretoriaId: string;
  usuarioResponsavelDiretoria: string;
  usuarioResponsavelDiretoriaPossuiPermissao: boolean;

  areaId: string;
  usuarioResponsavelArea: string;
  usuarioResponsavelAreaPossuiPermissao: boolean;

  departamentoid: string;
  usuarioResponsavelDepartamento: string;
  usuarioResponsavelDepartamentoPossuiPermissao: boolean;
}

export const obterProxNumBm = (contratoId: string, planilhaDeQuantidadeId?: null) =>
  api.get(`${controller}/ObterProxNumBm?contratoId=${contratoId}&planilhaDeQuantidadeId=${planilhaDeQuantidadeId}`);

export const VerificarSeUsuarioLogadoTemPermissaoEditarNiveis = (id: any) =>
  api.get<MedicaoUsuarioPermissaoNivel>(`Medicao/verificarSeUsuarioLogadoTemPermissaoEditarNiveis/${id}`);

export const CreatMedicao = (medicao: CreatBoletimMedicaoPorContrato) => {
  return api.post<any>(`medicao/creatBoletimMedicaoPorContrato`, medicao);
};

export const updateLinhaPlanilhaRateio;

export const updateMedicao = (dadosGeriasBoletimMedicao: DadosGeriasBoletimMedicao) => {
  return api.put<any>(`medicao/atualizarMedicao/${dadosGeriasBoletimMedicao.id}`, dadosGeriasBoletimMedicao);
};

export const GetBoletimMedicaoById = (id: any) => api.get<DadosGeriasBoletimMedicao>(`Medicao/ObterBoletimPorId/${id}`);
export const GetBoletimMedicaoPorContratoId = (id: any) =>
  api.get<CreatBoletimMedicaoPorContrato>(`Medicao/ObterBoletimPorContratoId/${id}`);

export const getAllBoletimMedicaoPorContrato = (contratoId: string) =>
  api.get<GetALlBmsPq>(`${controller}/getAllBoletimMedicaoPorContrato?contratoId=${contratoId}`);

export const GetAllResumoMedicoesCanceladasPorContratoId = (contratoId: string, planilhaDeQuantidadeId?: string) =>
  api.get<ResumoMedicoe[]>(`Medicao/GetAllResumoMedicoesCanceladasPorContratoId?contratoId=${contratoId}&planilhaDeQuantidadeId=${planilhaDeQuantidadeId}`);

export const getStatusRateio;

export const GetBoletimMedicao = (id: any) => api.get<BoletimMedicao>(`Medicao/${id}`);
export const GetAllAnexosDaMedicoes = () => api.get<AnexosMedicao[]>(`Medicao/ObterAnexosDaMedicoes`);
export const GetAllAnexosDaMedicoesByMedicaoId = (id: any) =>
  api.get<AnexosMedicao[]>(`Medicao/ObterAnexosDaMedicoes/${id}`);
export const GetAllBoletimAssinadoPorMedicaoId = (id: any) =>
  api.get<AnexoMedicaoAssinado[]>(`Medicao/ObterBoletimAssinadoPorMedicao/${id}`);
export const GetAllStatusMedicao = () => api.get<StatusMedicao[]>('Medicao/ObterTodosStatusMedicao');
export const GetAllStatusAutorizacaoPagamento = () =>
  api.get<StatusAutorizacaoPagamento[]>('Medicao/ObterTodosStatusAutorizacaoPagamento');
export const GetAllTipoMedicao = () => api.get<TipoMedicao[]>('Medicao/ObterTodosTipoMedicao');

export const gelAllResumoMedicoes = (contratoId: string, planilhaDeQuantidadeId?: string) =>
  api.get<ResumoMedicoe[]>(`Medicao/ObterResumoMedicoesPorContratoId?contratoId=${contratoId}&planilhaDeQuantidadeId=${planilhaDeQuantidadeId}`);

export const EditarMedicao = (medicaoEdit: any) => api.put(`Medicao/atualizarMedicao`, medicaoEdit);

export const GetAllStatusMedicaoAreasOptions = () =>
  GetAllStatusMedicao().then(statusMedicao =>
    (statusMedicao || []).map(a => ({ text: a.nome, value: a.id.toString() })),
  );

export const GetAllStatusAutorizacaoPagamentoOptions = () =>
  GetAllStatusAutorizacaoPagamento().then(statusMedicao =>
    (statusMedicao || []).map(a => ({ text: a.nome, value: a.id.toString() })),
  );

export const GetAllTipoMedicaoOptions = () =>
  GetAllTipoMedicao().then(tipoMedicao => (tipoMedicao || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const GetAllBoletimMedicao = (medicaoId?: string) => {
  let query = ''

  if (isObjNotEmpty(medicaoId)) {
    query += `medicaoId=${medicaoId}`
  }

  return api.get<ResumoMedicaoList[]>(`${controller}`);
};

export const GetAllToMenu = (contratoId ?: string) => {
  let url = `${controller}/GetToMenu`;
  if (contratoId){
      url += `?contratoId=${contratoId}`;
  }
  return api.get<any[]>(url)
}

export const GetSelectedFromMenu = (medicaoId?: string) => {
  return api.get<ResumoMedicaoList>(`${controller}/GetSelectedMenu?medicaoId=${medicaoId}`)
}

export const GetObterMedicaoPorId = (id: any) => api.get<MedicaoEdit>(`Medicao/ObterMedicaoEdit/${id}`);
export const GetAllAnexoMedicaoEditMedicao = (id: any) =>
  api.get<AnexosMedicao[]>(`Medicao/GetAllAnexoMedicaoEditMedicao/${id}`);
export const updateDescricaoAnexoBm = (id: any, form: any) =>
  api.put<any>(`Medicao/UpdateDescricaoAnexoBm/${id}`, form);
export const GetAllItensDaMedicoes = (id: any) =>
  api.get<ItemMedicao[]>(`Medicao/ObterItensMedicoesPorMedicaoId/${id}`);

export const updatePeriodoMedicao = (id: any, form: any) => api.put<any>(`Medicao/UpdatePeriodoMedicao/`, form);

export const ImportarPeriodoMedicao = (id: string, file: File) => {
  const form = new FormData();
  form.append('file', file);
  return api.post<any>(`Medicao/importarPeriodo/${id}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    disableNotification: true,
  });
};

export const ExportBoletimLinhaBm = (id: any) => {
  let urlBase = window.location.origin;
  Axios.get(urlBase + `/api/Medicao/exportarBmExcel/${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ExportacaoBoletimMedicao.xlsx');
    link.setAttribute('id', 'download_boletimMedicao');
    document.body.appendChild(link);
    link.click();
    document.getElementById('download_boletimMedicao').outerHTML = '';
  });
};

const DownloadZipAnexosLinhas = (endpoint: string, fallbackFileName: string) => {
  let urlBase = window.location.origin;
  return Axios.get(urlBase + endpoint, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const contentDisposition = resp.headers['content-disposition'] || '';
    const fileNameMatch = /filename="?([^";]+)"?/i.exec(contentDisposition);
    const fileName = fileNameMatch ? fileNameMatch[1] : fallbackFileName;
    const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
};

export const DownloadTodosAnexosLinhasMedicao = (medicaoId: string) =>
  DownloadZipAnexosLinhas(`/api/Medicao/baixarAnexosLinhas/${medicaoId}`, 'anexos_linhas_medicao.zip');

export const DownloadAnexosLinhaMedicao = (linhaBmId: string) =>
  DownloadZipAnexosLinhas(`/api/Medicao/baixarAnexosLinha/${linhaBmId}`, 'anexos_linha_medicao.zip');

// export const ExportBoletimLinhaBm = (id: any) => {
//   let urlBase = window.location.origin;
//   Axios.get(urlBase + `/api/Medicao/exportaBmMedicao/${id}`, {
//     responseType: 'blob',
//     headers: {
//       Authorization: `Bearer ${getJwt()}`,
//     },
//   }).then(resp => {
//     const url = window.URL.createObjectURL(new Blob([resp.data]));
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'boletimMedicao.pdf');
//     link.setAttribute('id', 'downloadPdfElementAnexoMedicao');
//     document.body.appendChild(link);
//     link.click();
//     document.getElementById('downloadPdfElementAnexoMedicao').outerHTML = '';
//   });
// };

export const ConfirmaQuantidadeBm = (id: any) => api.put(`Medicao/ConfirmaQuantidadeBm/${id}`);
export const AprovarRessalvaQuantidadeBm = (id: any) => api.put(`Medicao/AprovarRessalvaQuantidadeBm/${id}`);
export const ReprovarRessalvaQuantidadeBm = (id: any) => api.put(`Medicao/ReprovarRessalvaQuantidadeBm/${id}`);
export const AnalisouRessalvaReenviouBM = (id: any) => api.put(`Medicao/AnalisouRessalvaReenviouBM/${id}`);
export const ReprovarDadosBM = (id: any) => api.put(`Medicao/ReprovarDadosBM/${id}`);

export const ReprovarDadosQuantativos = (id: any) => api.put<ItemMedicao>(`Medicao/ReprovarDadosQuantativos/${id}`);
export const AprovarAnaliseQuantitativaBm = (id: any) =>
  api.put<ItemMedicao>(`Medicao/AprovarAnaliseQuantitativaBm/${id}`);
export const ReprovarAnaliseQuantitativaBm = (id: any) =>
  api.put<ItemMedicao>(`Medicao/ReprovarAnaliseQuantitativaBm/${id}`);
export const AprovarComRessalvaAnaliseQuantitativa = (id: any, form: any) =>
  api.put<ItemMedicao>(`Medicao/AprovarComRessalvaAnaliseQuantitativa/${id}`, form);
export const RefutarAnaliseQuantitativa = (id: any) => api.put<ItemMedicao>(`Medicao/RefutarAnaliseQuantitativa/${id}`);
export const ReconfirmarQuantidadeBm = (id: any) => api.put<ItemMedicao>(`Medicao/ReconfirmarQuantidadeBm/${id}`);
export const AprovarDadosBM = (id: any) => api.put<ItemMedicao>(`Medicao/AprovarDadosBM/${id}`);

export const AprovarDadosBmComRessalva = (id: any, form: any) =>
  api.put<ItemMedicao>(`Medicao/AprovarDadosBmComRessalva/${id}`, form);

export const RefutarMedicao = (id: any) => api.put<ItemMedicao>(`Medicao/RefutarMedicao/${id}`);
export const ConfirmarMedicao = (id: any) => api.put<ItemMedicao>(`Medicao/ConfirmarMedicao/${id}`);

export const AprovarCancelamentoBm = (id: any, form: any) =>
  api.put<ItemMedicao>(`Medicao/AprovarCancelamentoBm/${id}`, form);

export const CancelarBmPeloDropdown = (id: any, form: any) =>
  api.put<ItemMedicao>(`Medicao/CancelarBmPeloDropdown/${id}`, form);

export const ReprovarCancelamentoBm = (id: any) => api.put<ItemMedicao>(`Medicao/ReprovarCancelamentoBm/${id}`);
export const SolicitarCancelamentoBoletimMedicao = (id: any, form: any) =>
  api.put<ItemMedicao>(`Medicao/SolicitarCancelamentoBoletimMedicao/${id}`, form);

export const ReprovarSla = (id: any) => api.put<ItemMedicao>(`Medicao/ReprovarSla/${id}`);
export const ConfirmarSla = (id: any) => api.put<ItemMedicao>(`Medicao/ConfirmarSla/${id}`);

export const ExportarAnaliseSla = (id: any) => {
  let urlBase = window.location.origin;
  Axios.get(urlBase + `/api/Medicao/exportarAnaliseSla/${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'boletimMedicaoSla.pdf');
    link.setAttribute('id', 'downloadPdfElementAnexoMedicaoSla');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadPdfElementAnexoMedicaoSla').outerHTML = '';
  });
};

export const ObterComentarioPorMedicaoId = (id: any) =>
  api.get<Comentario[]>(`Medicao/obterComentarioPorMedicaoId/${id}`);
export const SalvarComentario = (form: any) =>
  api.post('Medicao/updateComentarioBm', form, {
    disableNotification: 'true',
  });

export const UpdateAprovarReprovar = (form: any) => api.post('Medicao/aprovarReprovar', form);

export const GetAllItensDaMedicoesSla = (id: any) => api.get<MedicaoSla>(`Medicao/GetAllItensDaMedicoesSla/${id}`);

export const GetAllAnexoMedicoesAssinadoSlaPorMedicaoId = (id: any) =>
  api.get<AnexoMedicaoAssinado[]>(`Medicao/GetAllAnexoMedicoesAssinadoSlaPorMedicaoId/${id}`);
export const GetAllAnexoMedicoesSlaPorMedicaoId = (id: any) =>
  api.get<AnexoMedicao[]>(`Medicao/GetAllAnexoMedicoesSlaPorMedicaoId/${id}`);
export const updateDescricaoAnexoBmSla = (form: any) => api.post<any>(`Medicao/updateDescricaoAnexoBmSla`, form);
export const DeletarAnexoMedicaoPorId = (id: any) => api.delete<any>(`Medicao/DeletarAnexoMedicaoPorId/${id}`);
export const DeletarAnexoMedicaoSla = (id: any) => api.delete<any>(`Medicao/DeletarAnexoMedicaoSlaPorId/${id}`);
export const updateGridSla = (form: any) => api.post<any>(`Medicao/updateGridSla`, form);

export const downloadAnexoAnaliseSla = (id: any, fileName: any) => {
  let urlBase = window.location.origin;

  Axios.get(urlBase + `/api/Medicao/downloadAnexoAnaliseSla?id=${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const viewAnexoAnaliseSla = async (arquivoInicialId, nomeDoArquivo) => {
  var url = window.location.origin + `/api/Medicao/downloadAnexoAnaliseSla?id=${arquivoInicialId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nomeDoArquivo);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

export const SalvarComentarioSla = (form: any) =>
  api.post('Medicao/updateComentarioSla', form, {
    disableNotification: 'true',
  });
export const ObterComentarioPorMedicaoSlaId = (id: any) =>
  api.get<Comentario[]>(`Medicao/obterComentarioSlaPorMedicaoId/${id}`);

export const DownloadAnexoMedidas = (id: any, fileName: any) => {
  let urlBase = window.location.origin;
  Axios.get(urlBase + `/api/Medicao/downloadAnexoMedidas?id=${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('id', 'downloadElementAnexoMedicao');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElementAnexoMedicao').outerHTML = '';
  });
};

export const ViewArquivoAnexoMedidas = async (arquivoInicialId, nomeDoArquivo) => {
  var url = window.location.origin + `/api/Medicao/downloadAnexoMedidas?id=${arquivoInicialId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nomeDoArquivo);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

export const DeletarAnexoBmMedicaoPorId = (id: any) =>
  api.delete<any>(`Medicao/DeletarAnexoMedicaoBmPorIdCommand/${id}`);
export const VerificarSeUsuarioPodeEditarMedicao = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioPodeEditarMedicao/${id}`);

//Mrn
export const VerificarSeuUsuarioLogadoGestorMrnSessao = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeuUsuarioLogadoGestorMrnSessao/${id}`);
export const VerificarSeUsuarioLogadoAdministradorDoContatoSessao = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoAdministradorDoContatoSessao/${id}`);

export const VerificarSeusUarioLogadoFornecedorDoContratoSessao = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeusUarioLogadoFornecedorDoContratoSessao/${id}`);
export const VerificarSeUsuarioLogadoForMrnSessao = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoForMrnSessao/${id}`);
export const VerificarSeUsuarioLogadoFiscalDoContrato = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoFiscalDoContrato/${id}`);
export const VerificarSeUsuarioLogadoFiscalAlternativoDoContrato = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoFiscalAlternativoDoContrato/${id}`);
export const VerificarSeUsuarioLogadoAdministradorAlternativoDoContratoMrn = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoAdministradorAlternativoDoContratoMrn/${id}`);

export const VerificarSeUsuarioLogadoTecnicoMedicaoMrn = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoTecnicoMedicaoMrn/${id}`);

//Fornecedor
export const VerificarSeUsuarioLogadoFiscalDoContratoFornecedor = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoFiscalDoContratoFornecedor/${id}`);
export const VerificarSeUsuarioLogadoGestorDoContratoFornecedor = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoGestorDoContratoFornecedor/${id}`);

export const VerificarSeUsuarioLogadoFinanceiroDoContratoFornecedor = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeUsuarioLogadoFinanceiroDoContratoFornecedor/${id}`);

export const DownloadAnexoLinhaMedidas = (id: any) => {
  let urlBase = window.location.origin;
  api.get<string>(`Medicao/ObterNomeFileAnexoArquivoLinhaMedicao/${id}`).then(nomeDoArquivo => {
    let fileName = nomeDoArquivo != null ? nomeDoArquivo : '';

    Axios.get(urlBase + `/api/Medicao/GetBlobDownloadAnexoArquivoLinhaMedicao?id=${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      link.setAttribute('id', 'downloadElementLinhaAnexoMedicao');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementLinhaAnexoMedicao').outerHTML = '';
    });
  });
};

export const GetAllTotalizarMedicao = (id: any) =>
  api.get<MedicaoTotalizador>(`Medicao/GetAllTotalizarMedicaoPorMedicaoId/${id}`);
export const VerificarSeBmEDoTipoAutomaticoEtemFrequenciaSlaSobDemanda = (id: any) =>
  api.get<boolean>(`Medicao/VerificarSeBmEDoTipoAutomaticoEtemFrequenciaSlaSobDemanda/${id}`);

export const VerificarLinhasBMPreenchidas = (id: any) => api.get<any>(`Medicao/VerificarLinhasBMPreenchidas/${id}`);

export const getAllPendencias = (id: any) => api.get<Pendencia[]>(`Medicao/pendencias/${id}`);
export const aprovarTodasPendencias = (id: any) => api.put(`Medicao/pendencias/${id}`);

export const AprovarQuantidadesDoPeriodo = (id: any) => api.put<any>(`Medicao/AprovarQuantidadesDoPeriodo/${id}`);
export const ReprovarQuantidadesDoPeriodo = (id: any) => api.put<any>(`Medicao/ReprovarQuantidadesDoPeriodo/${id}`);

export const getValorADistribuirPorTipoDocumento = (data: any) => {
  return api.post(`Medicao/GetValorADistribuirPorTipoDocumento`, data, { disableNotification: true });
};

export const medicaoConfirmadaOptions = [
  { text: 'Sim', value: true },
  { text: 'Não', value: false },
];

export const GetTimeline = (id: string) => api.get(`Medicao/Timeline/${id}`);
